<template>
  <div class="mr-5">
    <div class="info-line">
      <span class="text-label">
        Opérations attachées
      </span>
      <span class="text-count">
        <span v-if="isSelected">
          {{ selectedOperations.length }} / {{ operations.length }} Opérations
        </span>
        <span v-else>
          Total opérations: {{ String(operations.length).padStart(2, "0") }}
        </span>
      </span>
    </div>
    <table class="giga-table " :aria-describedby="$t('operations_list')">
      <thead>
        <tr style="background-color: #132D48; height: 25px" class="text-white">
          <th style="width: 3%;" v-if="isSelected">
            <input
              type="checkbox"
              @change="toggleAll"
              v-model="selectAllOperations"
              :class="{
                'disabled-checkbox': typeUniqueDouble || disableSelectAll
              }"
            />
          </th>
          <th class="text-white">
            {{ $t("plug_cee") }}
          </th>
          <th class="text-white">
            {{ $t("commitment_date") }}
          </th>
          <th class="w-30 text-white">
            {{ $t("address") }}
          </th>
          <th class="text-white">
            {{ $t("precarious_volume") }}
          </th>
          <th class="text-white">
            {{ $t("classic_volume") }}
          </th>
          <th class="text-white">
            {{ $t("status") }}
          </th>
          <th style="width: 3%;" v-if="isDeleted"></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="operation in operations">
          <tr
            class="cursor-pointer"
            :key="operation.id"
            style="background-color: #EBF3FA"
            :class="{
              'bg-light':
                !isStatusAllowed(operation.status) ||
                checkOperation(operation) ||
                typeUniqueDouble ||
                operationsToDisable.includes(operation.id),
              'text-muted':
                !isStatusAllowed(operation.status) ||
                checkOperation(operation) ||
                typeUniqueDouble ||
                operationsToDisable.includes(operation.id),
              'no-pointer-events':
                !isStatusAllowed(operation.status) ||
                checkOperation(operation) ||
                typeUniqueDouble ||
                operationsToDisable.includes(operation.id)
            }"
          >
            <td style="width: 3%;" v-if="isSelected">
              <input
                type="checkbox"
                :value="operation.id"
                v-model="selectedOperationsId"
                @change="onOperationSelection"
                :class="{
                  'disabled-checkbox':
                    !isStatusAllowed(operation.status) ||
                    checkOperation(operation) ||
                    typeUniqueDouble ||
                    operationsToDisable.includes(operation.id)
                }"
              />
            </td>
            <td>
              <p
                :class="{
                  'text-muted':
                    !isStatusAllowed(operation.status) ||
                    checkOperation(operation) ||
                    typeUniqueDouble ||
                    operationsToDisable.includes(operation.id)
                }"
              >
                {{ operation.ficheNumber }}
              </p>
            </td>
            <td>
              <p
                :class="{
                  'text-muted':
                    !isStatusAllowed(operation.status) ||
                    checkOperation(operation) ||
                    typeUniqueDouble ||
                    operationsToDisable.includes(operation.id)
                }"
              >
                {{
                  operation.beginDate
                    ? moment(operation.beginDate, "x").format("DD/MM/YYYY")
                    : ""
                }}
              </p>
            </td>
            <td>
              <p
                :class="{
                  'text-muted':
                    !isStatusAllowed(operation.status) ||
                    checkOperation(operation) ||
                    typeUniqueDouble ||
                    operationsToDisable.includes(operation.id)
                }"
              >
                {{ operation.siteName }}
              </p>
            </td>
            <td>
              <p
                :class="{
                  'text-muted':
                    !isStatusAllowed(operation.status) ||
                    checkOperation(operation) ||
                    typeUniqueDouble ||
                    operationsToDisable.includes(operation.id)
                }"
              >
                {{ operation.precarityVolume | formatNumber
                }}<span> kWh cumac</span>
              </p>
            </td>
            <td>
              <p
                :class="{
                  'text-muted':
                    !isStatusAllowed(operation.status) ||
                    checkOperation(operation) ||
                    typeUniqueDouble ||
                    operationsToDisable.includes(operation.id)
                }"
              >
                {{ operation.classicVolume | formatNumber
                }}<span> kWh cumac</span>
              </p>
            </td>
            <td>
              <p
                :class="{
                  'text-muted':
                    !isStatusAllowed(operation.status) ||
                    checkOperation(operation) ||
                    typeUniqueDouble ||
                    operationsToDisable.includes(operation.id)
                }"
              >
                <span v-if="isSimulation">
                  {{ $t("simulation_status." + getSimulation.status) }}</span
                >
                <span v-else>
                  {{ $t("operation_status." + operation.status) }}
                </span>
              </p>
            </td>
            <td v-if="isDeleted">
              <svg
                @click="deleteOperations(operation)"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="4 4 16 16"
                :stroke="isStatusAllowed(operation.status) ? 'red' : '#9CA3AF'"
                class="h-5 cursor-pointer"
                :class="{
                  'no-pointer-events': !isStatusAllowed(operation.status)
                }"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="4"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import { constants } from "@/shared/constants";
import { mapGetters } from "vuex";

export default {
  name: "OperationList",
  data() {
    return {
      selectAllOperations: false,
      selectedOperationsId: [],
      allowedStatus: constants.ALLOWED_OPERATIONS_STATUS,
      uniqueTypes: [
        "PREUVE_ENGAGEMENT",
        "PREUVE_REALISATION",
        "ATTESTATION_SUR_HONNEUR",
        "CERTIFICAT_RGE",
        "AUDIT_ENERGETIQUE",
        "SYNTHESE_AUDIT",
        "MANDAT",
        "MANDAT_BENEFICIAIRE",
        "AVIS_IMPOSITION",
        "ACT_SOUS_TRAITANCE",
        "JUSTIFICATIF_DOMICILE",
        "PIECE_IDENTITE",
        "NOTE_DIMENSIONNEMENT",
        "PREUVE_RAI"
      ],
      typeUniqueDouble: false,
      allDocuments: [],
      operationsToDisable: [],
      disableSelectAll: false
    };
  },
  props: {
    operations: {
      type: Array,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    isDeleted: {
      type: Boolean,
      default: false
    },
    selectedOperations: [],
    isSimulation: {
      type: Boolean,
      default: true
    },
    selectedDocument: {
      type: Object
    },
    isMassActions: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.allDocuments = this.getDocuments?.content
      .concat(this.getDraftDocuments)
      .concat(this.getDraftDocumentsReplace);
    if (this.isMassActions) {
      this.typeUniqueDouble = this.uniqueTypes.some(typeCode => {
        const occ = this.getSelectedDocuments.filter(document => {
          if (Array.isArray(document.types)) {
            return document.types.every(type => type.code === typeCode);
          } else {
            return document.types.code === typeCode;
          }
        }).length;
        return occ > 1;
      });
      const selectedDocuments = this.getSelectedDocuments;
      this.allDocuments
        .filter(
          document =>
            !selectedDocuments.map(doc => doc.id).includes(document.id)
        )
        .forEach(document => {
          const typesCode = Array.isArray(document.types)
            ? document.types.map(t => t.code)
            : [document.types.code];
          const selectedTypes = selectedDocuments.flatMap(doc =>
            doc.types.map(t => t.code)
          );
          if (
            typesCode.every(tc => selectedTypes.includes(tc)) &&
            typesCode.some(typeCode => this.uniqueTypes.includes(typeCode)) &&
            document.operations.length > 0
          ) {
            document.operations.forEach(operation => {
              if (!this.operationsToDisable.includes(operation.id)) {
                this.operationsToDisable.push(operation.id);
              }
            });
          }
        });
      if (this.operationsToDisable.length > 0 || this.typeUniqueDouble) {
        this.disableSelectAll = true;
      }
    } else {
      this.selectedOperationsId = this.selectedOperations?.map(
        operation => operation.id
      );
    }
  },
  computed: {
    ...mapGetters("simulation", ["getSimulation"]),
    ...mapGetters("document", [
      "getDocuments",
      "getDraftDocuments",
      "getDraftDocumentsReplace",
      "getSelectedDocuments"
    ])
  },
  methods: {
    toggleAll() {
      if (this.selectAllOperations) {
        this.selectedOperations = this.operations;
      } else {
        this.selectedOperations = [];
      }
      if (this.isMassActions) {
        this.selectedOperationsId = this.selectedOperations?.map(
          operation => operation.id
        );
        this.$emit("operation-selection-changed", this.selectedOperations);
      } else {
        this.onOperationSelection();
      }
    },
    onOperationSelection() {
      this.selectedOperations = this.operations.filter(o =>
        this.selectedOperationsId.includes(o.id)
      );
      this.$emit("operation-selection-changed", this.selectedOperations);
    },
    deleteOperations(operationDelete) {
      this.operations = this.operations.filter(
        operation => operation.id !== operationDelete.id
      );
      this.$emit("operation-deleted-changed", this.operations);
    },
    isStatusAllowed(status) {
      if (this.isSimulation || this.allowedStatus.includes(status)) {
        return true;
      }
      this.disableSelectAll = true;
      return false;
    },
    getAllDocuments() {
      return this.getDocuments?.content
        .concat(this.getDraftDocuments)
        .concat(this.getDraftDocumentsReplace);
    },
    checkOperation(operation) {
      if (this.isDeleted || this.isMassActions) {
        return false;
      }
      let selectedType = Array.isArray(this.selectedDocument.types)
        ? this.selectedDocument.types.filter(t =>
            this.uniqueTypes.includes(t.code)
          )
        : this.uniqueTypes.includes(this.selectedDocument.types.code);
      if (selectedType.length === 0) {
        return false;
      }
      const allDocs = this.getAllDocuments();
      const docWithUniqueType = allDocs
        ?.filter(
          doc =>
            doc !== null &&
            doc.types !== null &&
            (doc.id !== this.selectedDocument.id ||
              doc.fileName !== this.selectedDocument.fileName)
        )
        .filter(doc => {
          if (
            (Array.isArray(doc.types) &&
              doc.types.some(type => this.uniqueTypes.includes(type.code))) ||
            this.uniqueTypes.includes(doc.types.code)
          ) {
            this.disableSelectAll = true;
            return true;
          }
        });
      const operationsTypesMap = new Map();
      docWithUniqueType.forEach(doc => {
        doc.operations?.forEach(op => {
          const types = Array.isArray(doc.types) ? doc.types : [doc.types];
          if (operationsTypesMap.has(op.id)) {
            operationsTypesMap.set(
              op.id,
              operationsTypesMap.get(op.id).concat(types)
            );
          } else {
            operationsTypesMap.set(op.id, types);
          }
        });
      });
      if (operationsTypesMap.has(operation.id)) {
        if (
          (Array.isArray(this.selectedDocument.types) &&
            this.selectedDocument.types.some(type =>
              operationsTypesMap.get(operation.id).includes(type)
            )) ||
          operationsTypesMap
            .get(operation.id)
            .includes(this.selectedDocument.types)
        ) {
          this.disableSelectAll = true;
          return true;
        }
      }
      return false;
    }
  }
};
</script>

<style scoped lang="scss">
.info-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 10px 10px 10px;
}

.text-label {
  font-weight: 500;
  color: #01588b;
}

.text-count {
  font-weight: 500;
  font-size: 16px;
  color: #01588b;
}

.no-pointer-events {
  pointer-events: none;
}

.disabled-checkbox {
  opacity: 0.5;
  cursor: not-allowed;
  filter: grayscale(100%);
  pointer-events: none;
}
</style>
